import React from "react";

const RightPaginationIcon = (props: React.ComponentProps<"svg">) => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 1.33366L5.66667 6.00033L1 10.667"
      stroke="currentColor"
      strokeWidth={props.strokeWidth || "1.5"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RightPaginationIcon;
